import logo from "./../images/logo_clipped.png"

const Logo = () => {
  return (
    <img className="absolute top-2 left-2 sm:w-56 w-24" src={logo} alt="Shinshilla Logo" />
  )
}

export default Logo